import type { ReactElement } from 'react'

export interface MetricOption {
  id:           string
  name:         string
  description:  string
}

export interface SourceDetail {
  dims:        Record<string, string[]>
  range:       { min: number; max: number }
  chart_types: string[]
  url:         string | null
}

export interface FiltersResponse {
  sources: string[]
  default: string
  details: Record<string, SourceDetail>
}

export interface GeoItem {
  id:    string
  name?: string
}

export interface ActiveFilters {
  source:        string
  unit:          string
  compareGeo:    string[]
  yearRange:     [number, number]
  [dim: string]: any
}

export type ChartType = 'bar' | 'line'

export const GEO_COLORS = [
  '#e15759',  // červená (primárne geo)
  '#59a14f',  // zelená (compare 1)
  '#f28e2b',  // oranžová (compare 2)
  '#4e79a7',  // modrá (rezerva)
  '#76b7b2'  // tyrkysová (rezerva)
]

export interface Observation {
  i18nKey:    string
  values:     Record<string, string | number>
  components: ReactElement[]
}

/**
 * Porovnanie aktívneho filtra a aktuálneho výberu
 */
export function filtersEqual(a: ActiveFilters, b: ActiveFilters): boolean {
  return JSON.stringify(a) === JSON.stringify(b)
}